import { CountryInfo } from 'src/app/shared/models/country.model';

export const sortCountriesByName = (countriesList: CountryInfo[]): CountryInfo[] => {
  return countriesList.sort(
    (item1: CountryInfo, item2: CountryInfo) => item1.countryName > item2.countryName ? 1 : -1
  );
};
